<script setup lang="ts">
import ActionButton from '@/components/Elements/Buttons/ActionButton.vue'
import AlertBox from '@/components/Elements/Alerts/AlertBox.vue'
import TutorialFrame from '@/components/Interface/Modal/Modals/Tutorial/TutorialFrame.vue'
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import GenericIcon from '@/components/Elements/Images/Icons/GenericIcon.vue'
import { handleNext } from '../tutorialSteps'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const route = useRoute()
const router = useRouter()

const handleNextStep = async () => {
  await handleNext('tutorial_planet_defense', router)
}

const isOnPlanetsSection = computed(() => {
  return route.path.startsWith('/planets')
})

const goToPlanets = () => {
  router.push('/planets')
}

</script>

<template>
  <TutorialFrame
    video-url="https://cdn.ferion.com/videos/advisors/temperate/planet.webm"
  >
    <template #text>
      <p class="pb-2">
        {{ t('tutorial.planet.defense.title') }}
      </p>
      <p class="pb-2">
        {{ t('tutorial.planet.defense.passiveActive') }}
      </p>
      <p class="pb-2">
        <i18n-t keypath="tutorial.planet.defense.shieldsDescription" tag="span">
          <template #shieldsIcon><GenericIcon type="shields" /></template>
          <template #energyIcon><GenericIcon type="energy" /></template>
          <template #storageIcon><GenericIcon type="energy_storage" /></template>
        </i18n-t>
      </p>
      <p class="pb-2">
        {{ t('tutorial.planet.defense.groundWar') }}
      </p>
      <p class="pb-2">
        {{ t('tutorial.planet.defense.losePlanet') }}
      </p>
      <p class="pb-2">
        {{ t('tutorial.planet.defense.winBattle') }}
      </p>
    </template>

    <template #alerts>
      <AlertBox type="info" class="mb-2">
        <p class="pb-2">
          {{ t('tutorial.planet.defense.instructions') }}
        </p>
      </AlertBox>
    </template>

    <template #buttons>
      <ActionButton v-if="!isOnPlanetsSection" @click="goToPlanets" class="mr-2">
        {{ t('tutorial.planet.defense.goToPlanets') }}
      </ActionButton>
      <ActionButton @click="handleNextStep">
        {{ t('common.actions.understood') }}
      </ActionButton>
    </template>
  </TutorialFrame>
</template>

<style scoped lang="scss"></style>